import { render, staticRenderFns } from "./wholesale-grids-import-button.vue?vue&type=template&id=6af94075"
import script from "./wholesale-grids-import-button.vue?vue&type=script&lang=js"
export * from "./wholesale-grids-import-button.vue?vue&type=script&lang=js"
import style0 from "./wholesale-grids-import-button.vue?vue&type=style&index=0&id=6af94075&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports